import { ReactElement } from 'react';
import { Rating } from '@mantine/core';
import { YotpoReview } from '../../../models/product.types';
import { Badge } from '../../shared/badge/Badge';
import styles from '../ProductDisplayPage.module.scss';

type Props = {
  review: YotpoReview;
  onImageClick: (url: string) => void;
};

export function ReviewTile({
  review,
  onImageClick,
}: Props): ReactElement {
  return (
    <div className={styles.review_item}>
      {(review.images_data?.length ?? 0) > 0 && (
        <div className={styles.review_images}>
          {review.images_data.map((img) => (
            <button
              key={img.id}
              type="button"
              className={styles.review_image_button}
              onClick={() => onImageClick(img.original_url)}
            >
              <img
                src={img.original_url}
                alt="Review"
                className={styles.review_image}
                loading="lazy"
              />
            </button>
          ))}
        </div>
      )}
      <span className={styles.review_header_row}>
        <Rating
          value={review.score}
          readOnly
          size="sm"
        />
        <p className={styles.review_date}>
          {new Date(review.created_at).toLocaleDateString('en-US')}
        </p>
      </span>
      <p className={styles.review_title}>{review.title}</p>
      <p className={styles.review_content}>{review.content}</p>

      <div className={styles.review_author_row}>
        <p className={styles.review_author}>{review.user.display_name}</p>
        {review.verified_buyer && (
          <Badge
            text="✓ Verified Buyer"
            bgColor="#F0FDF4"
            color="#1E7E34"
            size="sm"
            borderColor="#B9F8CF"
          />
        )}
      </div>
    </div>
  );
}
